import { AggregateWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Aggregate')
export class AggregateNodeSchemaProvider extends SchemaProvider<AggregateWorkflowNode> {}
